import { AssetGroup } from "../models/asset";

export const AssetGroupDto = (data: any): AssetGroup => {
    return {
        id: data.id,
        name: data.name,
    };
}